// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.court-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.court-tooltip {
  position: absolute;
  left: 50%;
  top: 125%; /* Show below the icon */
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  white-space: nowrap;
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  letter-spacing: 0.5px;
}

.court-tooltip-wrapper:hover .court-tooltip,
.court-tooltip-wrapper:focus-within .court-tooltip {
  opacity: 1;
  pointer-events: auto;
}

.court-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #333;
}

.super-admin-module {
  --primary-light: #eff6ff;
  --primary-hover: #1d4ed8;
  --text-dark: #111827;
  --text-medium: #374151;
  --text-light: #6b7280;
  --text-muted: #9ca3af;
  --background: #f8fafc;
  --white: #ffffff;
  --border: #e5e7eb;
  --border-light: #f3f4f6;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1);
  --success-color: #059669;
  --success-light: #ecfdf5;
  --danger-color: #dc2626;
  --danger-light: #fef2f2;
  --warning-color: #d97706;
  --warning-light: #fffbeb;
  --info-color: #0891b2;
  --radius-sm: 8px;
  --radius: 12px;
  --radius-lg: 16px;
  min-height: 100vh;
  background-color: var(--background);
  padding: 2rem;
}
.super-admin-module h1 {
  text-align: center;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 800;
  background-color: var(--primary-color);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.025em;
}
.super-admin-module .tabs {
  padding: 4px;
  display: flex;
  justify-content: center;
  gap: 2px;
  margin-bottom: 1.5rem;
  background-color: #e2e8f0;
  border-radius: 8px;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
}
.super-admin-module .tabs button {
  flex: 1 1;
  padding: 8px 18px;
  border: 2px solid transparent;
  background-color: transparent;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--text-light);
  text-transform: capitalize;
  letter-spacing: 0.025em;
}
.super-admin-module .tabs button:hover:not(.active) {
  color: var(--text-medium);
  border-color: var(--border);
}
.super-admin-module .tabs button.active {
  background-color: #fff;
  color: #000;
}
.super-admin-module .invoices-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  position: relative;
}
.super-admin-module .invoices-header .left-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.super-admin-module .invoices-header .left-section .filter-sort-icons {
  display: flex;
  gap: 0.5rem;
}
.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--border-light);
  color: var(--text-medium);
  position: relative;
}
.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn svg {
  width: 16px;
  height: 16px;
}
.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn:hover {
  background: var(--border);
  color: var(--text-dark);
}
.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn.active {
  background: var(--primary-light);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn .filter-indicator {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
  border: 2px solid white;
}
.super-admin-module .invoices-header .left-section .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.super-admin-module .invoices-header .action-button-container {
  display: flex;
  gap: 10px;
  justify-content: end;
}
.super-admin-module .invoices-header .action-button-container .add-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.025em;
}
.super-admin-module .invoices-header .action-button-container .add-button .add-icon {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
}
.super-admin-module .invoices-header .action-button-container .add-button:active {
  transform: translateY(0);
}
.super-admin-module .filter-dropdown {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
  z-index: 99999;
  width: 365px;
  max-height: 40vh;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.super-admin-module .filter-dropdown .filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-light);
  flex-shrink: 0;
}
.super-admin-module .filter-dropdown .filter-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-dark);
}
.super-admin-module .filter-dropdown .filter-header .close-filter {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  color: var(--text-medium);
  transition: all 0.2s ease;
}
.super-admin-module .filter-dropdown .filter-header .close-filter:hover {
  background-color: var(--border-light);
  color: var(--text-dark);
}
.super-admin-module .filter-dropdown .filter-header .close-filter svg {
  width: 14px;
  height: 14px;
}
.super-admin-module .filter-dropdown .filter-content {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1 1;
  max-height: calc(80vh - 120px);
}
.super-admin-module .filter-dropdown .filter-content .filter-group {
  margin-bottom: 1rem;
}
.super-admin-module .filter-dropdown .filter-content .filter-group:last-child {
  margin-bottom: 1rem;
}
.super-admin-module .filter-dropdown .filter-content .filter-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-dark);
  font-size: 0.9rem;
}
.super-admin-module .filter-dropdown .filter-content .filter-group select {
  width: 100%;
  padding: 0.625rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background-color: var(--white);
  font-size: 0.9rem;
  color: var(--text-dark);
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .filter-dropdown .filter-content .filter-group select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.super-admin-module .filter-dropdown .filter-content .filter-group select:hover {
  border-color: var(--text-medium);
}
.super-admin-module .filter-dropdown .filter-content .filter-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 1rem;
  margin-top: auto;
  flex-shrink: 0;
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button {
  flex: 1 1;
  padding: 0.625rem 1rem;
  border: 1px solid;
  border-radius: var(--radius-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters {
  background-color: var(--white);
  border-color: var(--border);
  color: var(--text-medium);
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters:hover:not(:disabled) {
  background-color: var(--border-light);
  border-color: var(--text-medium);
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button.apply-filters {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--white);
}
.super-admin-module .filter-dropdown .filter-content .filter-actions button.apply-filters:hover {
  background-color: var(--primary-hover);
  border-color: var(--primary-hover);
}
.super-admin-module .no-results {
  text-align: center;
  padding: 3rem 2rem;
  color: var(--text-medium);
  background: var(--white);
  border-radius: var(--radius);
  border: 1px solid var(--border-light);
}
.super-admin-module .no-results p {
  margin-bottom: 1rem;
  font-size: 1rem;
}
.super-admin-module .no-results .clear-filters-btn {
  padding: 0.625rem 1.25rem;
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  border-radius: var(--radius-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .no-results .clear-filters-btn:hover {
  background-color: var(--primary-hover);
}
.super-admin-module .tab-content .card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 2rem;
  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  align-items: start;
}
.super-admin-module .tab-content .card-container .card {
  position: relative;
  background: var(--white);
  border: 1px solid var(--border);
  padding: 2rem;
  border-radius: var(--radius-lg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  min-height: 465px;
  display: flex;
  flex-direction: column;
}
.super-admin-module .tab-content .card-container .card:hover {
  border-color: var(--primary-light);
}
.super-admin-module .tab-content .card-container .card .card-actions {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  display: flex;
  gap: 0.5rem;
  transition: opacity 0.3s ease;
}
.super-admin-module .tab-content .card-container .card .card-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
}
.super-admin-module .tab-content .card-container .card .card-actions button svg {
  width: 16px;
  height: 16px;
}
.super-admin-module .tab-content .card-container .card h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--text-dark);
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  padding-right: 5rem;
  line-height: 1.3;
}
.super-admin-module .tab-content .card-container .card .card-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex-grow: 1;
}
.super-admin-module .tab-content .card-container .card .info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container .card .info-item:last-child {
  border-bottom: none;
}
.super-admin-module .tab-content .card-container .card .info-item .label {
  font-weight: 600;
  color: var(--text-medium);
  min-width: 80px;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container .card .info-item .value {
  color: var(--text-light);
  font-size: 0.95rem;
  line-height: 1.5;
  flex: 1 1;
}
.super-admin-module .tab-content .card-container .card .info-item .value.highlight {
  color: var(--primary-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container .card .info-item .value.success {
  color: var(--success-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container .card .info-item .value.danger {
  color: var(--danger-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container .card .info-item a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container .card .info-item a:hover {
  text-decoration: underline;
}
.super-admin-module .tab-content .card-container .card .accordion-header {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: var(--primary-light);
  border: none;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: var(--radius-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
}
.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle span {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle:hover {
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container .card .rights-container {
  margin-top: 1rem;
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: var(--text-medium);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle:hover {
  background: var(--primary-light);
  transform: scale(1.1);
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.enabled {
  background: var(--success-light);
  color: var(--success-color);
  border: 1px solid rgba(5, 150, 105, 0.2);
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.enabled::before {
  content: "✓";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.disabled {
  background: var(--border-light);
  color: var(--text-muted);
}
.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.disabled::before {
  content: "✕";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container .card .expandable-content {
  overflow: hidden;
  height: 0;
  opacity: 0;
}
.super-admin-module .tab-content .card-container .card .expandable-content .card-content {
  padding-top: 0.5rem;
}
.super-admin-module .tab-content .card-container .card .expandable-content .rights-container {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container .card .expandable-content .rights-container .rights-header {
  margin-bottom: 0.75rem;
  justify-content: flex-start;
}
.super-admin-module .tab-content .card-container .card .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container .card .status-badge.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container .card .status-badge.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container .card .status-badge.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container .card .status-badge.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.active:hover {
  background: #d1fae5;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive:hover {
  background: #fecaca;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container .card .sync-courts-section {
  margin-top: 1.5rem;
}
.super-admin-module .tab-content .card-container .card .sync-courts-section .sync-courts-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container .card .sync-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-button-wrapper {
  width: 49%;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn {
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync {
  width: 100%;
  background: var(--primary-color);
  color: white;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {
  background: var(--primary-hover);
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync {
  width: 49%;
  background: var(--info-color);
  color: white;
  cursor: pointer;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {
  background: #0e7490;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--text-dark);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip .check-status-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 0.75rem;
  text-decoration: underline;
  padding: 0;
}
.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip .check-status-btn:hover {
  color: var(--primary-hover);
}
.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--text-dark);
}
.super-admin-module .tab-content .card-container .card .sync-buttons .processing-tooltip {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--warning-color);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container .card .sync-buttons .processing-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--warning-color);
}
.super-admin-module .tab-content .card-container-plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 2rem;
  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  align-items: start;
}
.super-admin-module .tab-content .card-container-plans .card {
  position: relative;
  background: var(--white);
  border: 1px solid var(--border);
  padding: 2rem;
  border-radius: var(--radius-lg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  min-height: 280px;
  display: flex;
  flex-direction: column;
}
.super-admin-module .tab-content .card-container-plans .card:hover {
  border-color: var(--primary-light);
}
.super-admin-module .tab-content .card-container-plans .card .card-actions {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  display: flex;
  gap: 0.5rem;
  transition: opacity 0.3s ease;
}
.super-admin-module .tab-content .card-container-plans .card .card-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
}
.super-admin-module .tab-content .card-container-plans .card .card-actions button svg {
  width: 16px;
  height: 16px;
}
.super-admin-module .tab-content .card-container-plans .card h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--text-dark);
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  padding-right: 5rem;
  line-height: 1.3;
}
.super-admin-module .tab-content .card-container-plans .card .card-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex-grow: 1;
}
.super-admin-module .tab-content .card-container-plans .card .info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-plans .card .info-item:last-child {
  border-bottom: none;
}
.super-admin-module .tab-content .card-container-plans .card .info-item .label {
  font-weight: 600;
  color: var(--text-medium);
  min-width: 80px;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-plans .card .info-item .value {
  color: var(--text-light);
  font-size: 0.95rem;
  line-height: 1.5;
  flex: 1 1;
}
.super-admin-module .tab-content .card-container-plans .card .info-item .value.highlight {
  color: var(--primary-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-plans .card .info-item .value.success {
  color: var(--success-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-plans .card .info-item .value.danger {
  color: var(--danger-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-plans .card .info-item a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container-plans .card .info-item a:hover {
  text-decoration: underline;
}
.super-admin-module .tab-content .card-container-plans .card .accordion-header {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: var(--primary-light);
  border: none;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: var(--radius-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
}
.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle span {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle:hover {
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container {
  margin-top: 1rem;
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: var(--text-medium);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle:hover {
  background: var(--primary-light);
  transform: scale(1.1);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.enabled {
  background: var(--success-light);
  color: var(--success-color);
  border: 1px solid rgba(5, 150, 105, 0.2);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.enabled::before {
  content: "✓";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.disabled {
  background: var(--border-light);
  color: var(--text-muted);
}
.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.disabled::before {
  content: "✕";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container-plans .card .expandable-content {
  overflow: hidden;
  height: 0;
  opacity: 0;
}
.super-admin-module .tab-content .card-container-plans .card .expandable-content .card-content {
  padding-top: 0.5rem;
}
.super-admin-module .tab-content .card-container-plans .card .expandable-content .rights-container {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-plans .card .expandable-content .rights-container .rights-header {
  margin-bottom: 0.75rem;
  justify-content: flex-start;
}
.super-admin-module .tab-content .card-container-plans .card .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-plans .card .status-badge.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-badge.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-badge.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-badge.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active:hover {
  background: #d1fae5;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive:hover {
  background: #fecaca;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-plans .card .sync-courts-section {
  margin-top: 1.5rem;
}
.super-admin-module .tab-content .card-container-plans .card .sync-courts-section .sync-courts-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-button-wrapper {
  width: 49%;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn {
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync {
  width: 100%;
  background: var(--primary-color);
  color: white;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {
  background: var(--primary-hover);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync {
  width: 49%;
  background: var(--info-color);
  color: white;
  cursor: pointer;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {
  background: #0e7490;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--text-dark);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip .check-status-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 0.75rem;
  text-decoration: underline;
  padding: 0;
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip .check-status-btn:hover {
  color: var(--primary-hover);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--text-dark);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .processing-tooltip {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--warning-color);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container-plans .card .sync-buttons .processing-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--warning-color);
}
.super-admin-module .tab-content .card-container-company {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 2rem;
  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  align-items: start;
}
.super-admin-module .tab-content .card-container-company .card {
  position: relative;
  background: var(--white);
  border: 1px solid var(--border);
  padding: 2rem;
  border-radius: var(--radius-lg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  min-height: 700px;
  display: flex;
  flex-direction: column;
}
.super-admin-module .tab-content .card-container-company .card:hover {
  border-color: var(--primary-light);
}
.super-admin-module .tab-content .card-container-company .card .card-actions {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  display: flex;
  gap: 0.5rem;
  transition: opacity 0.3s ease;
}
.super-admin-module .tab-content .card-container-company .card .card-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
}
.super-admin-module .tab-content .card-container-company .card .card-actions button svg {
  width: 16px;
  height: 16px;
}
.super-admin-module .tab-content .card-container-company .card h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--text-dark);
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  padding-right: 5rem;
  line-height: 1.3;
}
.super-admin-module .tab-content .card-container-company .card .card-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex-grow: 1;
}
.super-admin-module .tab-content .card-container-company .card .info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-company .card .info-item:last-child {
  border-bottom: none;
}
.super-admin-module .tab-content .card-container-company .card .info-item .label {
  font-weight: 600;
  color: var(--text-medium);
  min-width: 80px;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-company .card .info-item .value {
  color: var(--text-light);
  font-size: 0.95rem;
  line-height: 1.5;
  flex: 1 1;
}
.super-admin-module .tab-content .card-container-company .card .info-item .value.highlight {
  color: var(--primary-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-company .card .info-item .value.success {
  color: var(--success-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-company .card .info-item .value.danger {
  color: var(--danger-color);
  font-weight: 600;
}
.super-admin-module .tab-content .card-container-company .card .info-item a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container-company .card .info-item a:hover {
  text-decoration: underline;
}
.super-admin-module .tab-content .card-container-company .card .accordion-header {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: var(--primary-light);
  border: none;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: var(--radius-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
}
.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle span {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle:hover {
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-company .card .rights-container {
  margin-top: 1rem;
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: var(--text-medium);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--primary-color);
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle:hover {
  background: var(--primary-light);
  transform: scale(1.1);
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 500;
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.enabled {
  background: var(--success-light);
  color: var(--success-color);
  border: 1px solid rgba(5, 150, 105, 0.2);
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.enabled::before {
  content: "✓";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.disabled {
  background: var(--border-light);
  color: var(--text-muted);
}
.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.disabled::before {
  content: "✕";
  font-weight: 700;
}
.super-admin-module .tab-content .card-container-company .card .expandable-content {
  overflow: hidden;
  height: 0;
  opacity: 0;
}
.super-admin-module .tab-content .card-container-company .card .expandable-content .card-content {
  padding-top: 0.5rem;
}
.super-admin-module .tab-content .card-container-company .card .expandable-content .rights-container {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-company .card .expandable-content .rights-container .rights-header {
  margin-bottom: 0.75rem;
  justify-content: flex-start;
}
.super-admin-module .tab-content .card-container-company .card .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .card-container-company .card .status-badge.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-company .card .status-badge.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-company .card .status-badge.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-company .card .status-badge.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active:hover {
  background: #d1fae5;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive:hover {
  background: #fecaca;
  transform: translateY(-1px);
}
.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .card-container-company .card .sync-courts-section {
  margin-top: 1.5rem;
}
.super-admin-module .tab-content .card-container-company .card .sync-courts-section .sync-courts-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-button-wrapper {
  width: 49%;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn {
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync {
  width: 100%;
  background: var(--primary-color);
  color: white;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {
  background: var(--primary-hover);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync {
  width: 49%;
  background: var(--info-color);
  color: white;
  cursor: pointer;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {
  background: #0e7490;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--text-dark);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip .check-status-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 0.75rem;
  text-decoration: underline;
  padding: 0;
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip .check-status-btn:hover {
  color: var(--primary-hover);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--text-dark);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .processing-tooltip {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--warning-color);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: var(--shadow);
}
.super-admin-module .tab-content .card-container-company .card .sync-buttons .processing-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--warning-color);
}
.super-admin-module .tab-content .table-wrapper {
  position: relative;
  width: 100%;
}
.super-admin-module .tab-content .table-wrapper::before, .super-admin-module .tab-content .table-wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  z-index: 11;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.super-admin-module .tab-content .table-wrapper::before {
  left: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.1), transparent);
}
.super-admin-module .tab-content .table-wrapper::after {
  right: 0;
  background: linear-gradient(270deg, rgba(0, 0, 0, 0.1), transparent);
}
.super-admin-module .tab-content .table-wrapper.show-left-fade::before {
  opacity: 1;
}
.super-admin-module .tab-content .table-wrapper.show-right-fade::after {
  opacity: 1;
}
.super-admin-module .tab-content .table-container {
  overflow-x: auto;
  width: 100%;
  overflow-y: hidden;
  position: relative;
}
.super-admin-module .tab-content .top-scrollbar-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 17px;
  margin-bottom: 8px;
  background-color: var(--background);
  border-radius: var(--radius-sm);
}
.super-admin-module .tab-content .top-scrollbar-container::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 6px;
  border: 2px solid var(--border-light);
}
.super-admin-module .tab-content .top-scrollbar-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}
.super-admin-module .tab-content .top-scrollbar-content {
  height: 1px;
  pointer-events: none;
}
.super-admin-module .tab-content .scroll-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  backdrop-filter: blur(2px);
  pointer-events: none;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.super-admin-module .tab-content .scroll-indicator span {
  font-size: 18px;
  font-weight: bold;
  color: var(--primary-color);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  animation: pulse 2s infinite;
}
.super-admin-module .tab-content .scroll-indicator.left-scroll {
  left: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.3));
  border-top-left-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.super-admin-module .tab-content .scroll-indicator.right-scroll {
  right: 0;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.3));
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
.super-admin-module .tab-content .data-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.95rem;
  box-shadow: var(--shadow-sm);
}
.super-admin-module .tab-content .data-table thead {
  background-color: #f1f5f9;
}
.super-admin-module .tab-content .data-table thead th {
  text-align: left;
  padding: 1rem;
  color: var(--text-dark);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
}
.super-admin-module .tab-content .data-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid var(--border-light);
}
.super-admin-module .tab-content .data-table tbody tr:hover {
  background-color: #f9fafb;
}
.super-admin-module .tab-content .data-table tbody tr:last-child {
  border-bottom: none;
}
.super-admin-module .tab-content .data-table tbody tr td {
  padding: 0.9rem 1rem;
  color: var(--text-medium);
  font-size: 0.9rem;
  vertical-align: middle;
}
.super-admin-module .tab-content .data-table .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.super-admin-module .tab-content .data-table .status-badge.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .data-table .status-badge.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .data-table .status-badge.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .data-table .status-badge.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .data-table .status-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border: none;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s ease;
}
.super-admin-module .tab-content .data-table .status-toggle-btn.active {
  background: var(--success-light);
  color: var(--success-color);
}
.super-admin-module .tab-content .data-table .status-toggle-btn.active:hover {
  background: #d1fae5;
}
.super-admin-module .tab-content .data-table .status-toggle-btn.active::before {
  content: "●";
  color: var(--success-color);
}
.super-admin-module .tab-content .data-table .status-toggle-btn.inactive {
  background: var(--danger-light);
  color: var(--danger-color);
}
.super-admin-module .tab-content .data-table .status-toggle-btn.inactive:hover {
  background: #fecaca;
}
.super-admin-module .tab-content .data-table .status-toggle-btn.inactive::before {
  content: "●";
  color: var(--danger-color);
}
.super-admin-module .tab-content .data-table .table-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.super-admin-module .tab-content .data-table .table-actions button {
  padding: 0.3rem 0.6rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.super-admin-module .tab-content .data-table .table-actions button.edit-btn {
  background-color: var(--info-color);
  color: white;
}
.super-admin-module .tab-content .data-table .table-actions button.edit-btn:hover {
  background-color: #0e7490;
}
.super-admin-module .tab-content .data-table .table-actions button.del-btn {
  background-color: var(--danger-color) !important;
  color: white !important;
}
.super-admin-module .tab-content .data-table .table-actions button.del-btn:hover {
  background-color: #b91c1c;
}
.super-admin-module .tab-content .data-table .table-actions .court-details-btn {
  background-color: var(--warning-color);
  color: white;
}
.super-admin-module .tab-content .data-table .table-actions .court-details-btn:hover {
  background-color: #b45309;
}
.super-admin-module .tab-content .data-table .table-sync-actions {
  display: flex;
  gap: 0.5rem;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small {
  padding: 0.3rem 0.6rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  text-transform: uppercase;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync {
  background: var(--primary-color);
  color: white;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync:hover:not(:disabled) {
  background: var(--primary-hover);
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync {
  background: var(--primary-color);
  color: white;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync:hover:not(:disabled) {
  background: #0e7490;
}
.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}
@media (max-width: 768px) {
  .super-admin-module {
    padding: 1rem;
  }
  .super-admin-module h1 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  .super-admin-module .tabs {
    max-width: 100%;
    flex-direction: column;
    height: auto;
  }
  .super-admin-module .tabs button {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }
  .super-admin-module .tabs button.active {
    background: var(--primary-color);
  }
  .super-admin-module .invoices-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .super-admin-module .invoices-header .left-section {
    justify-content: space-between;
    width: 100%;
  }
  .super-admin-module .invoices-header .left-section .filter-sort-icons {
    order: 1;
  }
  .super-admin-module .invoices-header .left-section .view-toggle-wrapper {
    order: 2;
  }
  .super-admin-module .invoices-header .action-button-container {
    justify-content: center;
    order: 3;
  }
  .super-admin-module .tab-content .card-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  .super-admin-module .tab-content .card-container .card {
    padding: 1.5rem;
    min-height: auto;
  }
  .super-admin-module .tab-content .card-container .card .card-actions {
    opacity: 1;
  }
  .super-admin-module .tab-content .card-container .card h3 {
    font-size: 1.25rem;
    padding-right: 4rem;
  }
  .super-admin-module .tab-content .card-container .card .info-item .label {
    min-width: 70px;
    font-size: 0.8rem;
  }
  .super-admin-module .tab-content .card-container .card .info-item .value {
    font-size: 0.9rem;
  }
  .super-admin-module .tab-content .card-container .card .rights-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 0.4rem;
  }
  .super-admin-module .tab-content .card-container .card .rights-grid .right-item {
    font-size: 0.8rem;
    padding: 0.4rem 0.6rem;
  }
  .super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
  .super-admin-module .tab-content .card-container .card .expandable-content .info-item .label {
    min-width: 60px;
    font-size: 0.75rem;
  }
  .super-admin-module .tab-content .card-container .card .expandable-content .info-item .value {
    font-size: 0.85rem;
  }
  .super-admin-module .tab-content .data-table {
    font-size: 0.8rem;
  }
  .super-admin-module .tab-content .data-table thead th {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }
  .super-admin-module .tab-content .data-table tbody td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }
  .super-admin-module .tab-content .data-table .table-actions {
    flex-direction: column;
    gap: 0.25rem;
  }
  .super-admin-module .tab-content .data-table .table-actions button {
    padding: 0.25rem 0.5rem;
    font-size: 0.7rem;
  }
  .super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small {
    padding: 0.3rem 0.6rem;
    font-size: 0.65rem;
  }
}
@media (max-width: 480px) {
  .super-admin-module .data-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .super-admin-module .data-table thead,
  .super-admin-module .data-table tbody,
  .super-admin-module .data-table th,
  .super-admin-module .data-table td,
  .super-admin-module .data-table tr {
    display: block;
  }
  .super-admin-module .data-table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .super-admin-module .data-table tr {
    border: 1px solid var(--border);
    margin-bottom: 1rem;
    padding: 1rem;
    border-radius: var(--radius);
    background: var(--white);
    box-shadow: var(--shadow-sm);
  }
  .super-admin-module .data-table td {
    border: none;
    border-bottom: 1px solid var(--border-light);
    position: relative;
    padding: 0.75rem 0 0.75rem 35%;
    white-space: normal;
    text-align: left;
  }
  .super-admin-module .data-table td:before {
    position: absolute;
    top: 0.75rem;
    left: 0.5rem;
    width: 30%;
    padding-right: 0.5rem;
    white-space: nowrap;
    font-weight: 600;
    color: var(--text-medium);
    font-size: 0.75rem;
    text-transform: uppercase;
  }
  .super-admin-module .data-table td:nth-child(1):before {
    content: "Name:";
  }
  .super-admin-module .data-table td:nth-child(2):before {
    content: "Email:";
  }
  .super-admin-module .data-table td:nth-child(3):before {
    content: "Role/Phone:";
  }
  .super-admin-module .data-table td:nth-child(4):before {
    content: "Status/Users:";
  }
  .super-admin-module .data-table td:nth-child(5):before {
    content: "Created/Branches:";
  }
  .super-admin-module .data-table td:nth-child(6):before {
    content: "Branches/Scraping:";
  }
  .super-admin-module .data-table td:nth-child(7):before {
    content: "Type/Sync:";
  }
  .super-admin-module .data-table td:nth-child(8):before {
    content: "Actions:";
  }
}

.action-required-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0.375rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: subtle-pulse 2s infinite;
}
.action-required-badge.card-badge-positioned {
  position: absolute;
  top: 4.5rem;
  right: 0.75rem;
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  z-index: 10;
}
.action-required-badge.card-badge-positioned::before {
  font-size: 0.75rem;
}
.action-required-badge.table-badge {
  margin-left: 0.5rem;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}

.horizontal-scroll-badge {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
  padding-right: 0.5rem;
}
.horizontal-scroll-badge .action-required-badge.table-badge {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.4rem 0.75rem;
  border-radius: 0.5rem;
  text-transform: none;
  letter-spacing: 0.025em;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
  animation: subtle-pulse 2s infinite;
}

@keyframes gentle-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
}
.card {
  position: relative;
}
.card .card-actions {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  display: flex;
  gap: 0.5rem;
  transition: opacity 0.3s ease;
}
.card .card-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
}
.card .card-actions button svg {
  width: 16px;
  height: 16px;
}
.card:hover .card-actions {
  opacity: 1;
}
.card h3 {
  padding-right: 6rem;
}

.sa-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.sa-dashboard-header h1 {
  margin: 0;
  flex-shrink: 0;
}
.sa-dashboard-header .tabs {
  display: flex;
  gap: 10px;
  margin: 0;
}

@media (max-width: 768px) {
  .action-required-badge.card-badge-positioned {
    top: 4rem;
    right: 0.5rem;
    font-size: 0.65rem;
    padding: 0.2rem 0.4rem;
  }
  .card h3 {
    padding-right: 5rem;
  }
  .table-cell-with-badge {
    flex-direction: column;
    align-items: flex-start;
  }
  .table-cell-with-badge .action-required-badge {
    margin-left: 0;
    margin-top: 0.25rem;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.sa-search-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  gap: 0.5rem;
}

.sa-search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.sa-search-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: white;
}

.sa-search-loading {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary-color);
}

.sa-spinner {
  animation: spin 1s linear infinite;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}
.pagination-controls button {
  padding: 6px 12px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
}
.pagination-controls button:disabled {
  background: var(--primary-color);
  cursor: not-allowed;
  opacity: 0.6;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 400;
}
.pagination-settings #saPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #saPerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #saPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #saPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.icon-btn.active {
  background-color: #f0f0f0;
  color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/SuperAdminModule/SuperAdminModule.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,SAAA,EAAA,wBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AACF;;AACA;EACE,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0CAAA;EACA,yCAAA;EACA,8CAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EAEA,iBAAA;EACA,mCAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBAAA;AACJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AACI;EACE,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,0BAAA;EACA,uBAAA;AACN;AAEM;EACE,yBAAA;EACA,2BAAA;AAAR;AAGM;EACE,sBAAA;EACA,WAAA;AADR;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAJN;AAMM;EACE,aAAA;EACA,WAAA;AAJR;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AAJV;AAMU;EACE,WAAA;EACA,YAAA;AAJZ;AAOU;EACE,yBAAA;EACA,uBAAA;AALZ;AAQU;EACE,gCAAA;EACA,2BAAA;EACA,sCAAA;AANZ;AASU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;AAPZ;AAYM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAVR;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAVV;AAYU;EACE,eAAA;EACA,cAAA;AAVZ;AAaU;EACE,yBAAA;AAXZ;AAcU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAZZ;AAkBI;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAhBN;AAkBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAhBR;AAkBQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhBV;AAmBQ;EACE,wBAAA;AAjBV;AAwBE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,4CAAA;EACA,cAAA;AAtBN;AAwBM;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAtBR;AAyBM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAvBR;AAyBQ;EACE,qCAAA;EACA,uBAAA;AAvBV;AA0BQ;EACE,WAAA;EACA,YAAA;AAxBV;AA6BI;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;AA3BN;AA6BM;EACE,mBAAA;AA3BR;AA6BQ;EACE,mBAAA;AA3BV;AA8BQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AA5BV;AA+BQ;EACE,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AA7BV;AA+BU;EACE,aAAA;EACA,kCAAA;EACA,4CAAA;AA7BZ;AAgCU;EACE,gCAAA;AA9BZ;AAmCM;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAjCR;AAmCQ;EACE,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAjCV;AAmCU;EACE,8BAAA;EACA,2BAAA;EACA,yBAAA;AAjCZ;AAmCY;EACE,qCAAA;EACA,gCAAA;AAjCd;AAoCY;EACE,YAAA;EACA,mBAAA;AAlCd;AAsCU;EACE,sCAAA;EACA,kCAAA;EACA,mBAAA;AApCZ;AAsCY;EACE,sCAAA;EACA,kCAAA;AApCd;AA6CE;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,qCAAA;AA3CJ;AA6CI;EACE,mBAAA;EACA,eAAA;AA3CN;AA8CI;EACE,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA5CN;AA8CM;EACE,sCAAA;AA5CR;AAmDI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mDAAA;EACA,kBAAA;AAjDN;AAmDM;EACE,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,aAAA;EACA,+BAAA;EACA,iDAAA;EACA,gBAAA;EAEA,iBAAA;EACA,aAAA;EACA,sBAAA;AAlDR;AAoDQ;EACE,kCAAA;AAlDV;AAqDQ;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAnDV;AAqDU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAnDZ;AAqDY;EACE,WAAA;EACA,YAAA;AAnDd;AAmFQ;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AAjFV;AAoFQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAlFV;AAqFQ;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;AAnFV;AAqFU;EACE,mBAAA;AAnFZ;AAsFU;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AApFZ;AAuFU;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AArFZ;AAuFY;EACE,2BAAA;EACA,gBAAA;AArFd;AAwFY;EACE,2BAAA;EACA,gBAAA;AAtFd;AAyFY;EACE,0BAAA;EACA,gBAAA;AAvFd;AA2FU;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AAzFZ;AA2FY;EACE,0BAAA;AAzFd;AA+FQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AA7FV;AA+FU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AA7FZ;AA+FY;EACE,yBAAA;EACA,sBAAA;AA7Fd;AAgGY;EACE,uDAAA;EACA,2BAAA;AA9Fd;AAiGY;EACE,2BAAA;AA/Fd;AAoGQ;EACE,gBAAA;AAlGV;AAoGU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAlGZ;AAoGY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,2BAAA;AAlGd;AAoGc;EACE,uDAAA;AAlGhB;AAqGc;EACE,gCAAA;EACA,qBAAA;AAnGhB;AAwGU;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AAtGZ;AAwGY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAtGd;AAwGc;EACE,gCAAA;EACA,2BAAA;EACA,wCAAA;AAtGhB;AAwGgB;EACE,YAAA;EACA,gBAAA;AAtGlB;AA0Gc;EACE,+BAAA;EACA,wBAAA;AAxGhB;AA0GgB;EACE,YAAA;EACA,gBAAA;AAxGlB;AA+GQ;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA7GV;AA+GU;EACE,mBAAA;AA7GZ;AAgHU;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA9GZ;AAgHY;EACE,sBAAA;EACA,2BAAA;AA9Gd;AAmHQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAjHV;AAmHU;EACE,gCAAA;EACA,2BAAA;AAjHZ;AAmHY;EACE,YAAA;EACA,2BAAA;AAjHd;AAqHU;EACE,+BAAA;EACA,0BAAA;AAnHZ;AAqHY;EACE,YAAA;EACA,0BAAA;AAnHd;AAwHQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AAtHV;AAwHU;EACE,gCAAA;EACA,2BAAA;AAtHZ;AAwHY;EACE,mBAAA;EACA,2BAAA;AAtHd;AAyHY;EACE,YAAA;EACA,2BAAA;AAvHd;AA2HU;EACE,+BAAA;EACA,0BAAA;AAzHZ;AA2HY;EACE,mBAAA;EACA,2BAAA;AAzHd;AA4HY;EACE,YAAA;EACA,0BAAA;AA1Hd;AA+HQ;EACE,kBAAA;AA7HV;AA+HU;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4CAAA;AA7HZ;AAiIQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AA/HV;AAiIU;EACE,UAAA;AA/HZ;AAkIU;EACE,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,uBAAA;AAhIZ;AAkIY;EACE,WAAA;EACA,gCAAA;EACA,YAAA;AAhId;AAkIc;EACE,gCAAA;AAhIhB;AAmIc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AAjIhB;AAqIY;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAnId;AAqIc;EACE,mBAAA;AAnIhB;AAsIc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AApIhB;AAyIU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAvIZ;AAyIY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;AAvId;AAyIc;EACE,2BAAA;AAvIhB;AA2IY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,sCAAA;AAzId;AA6IU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,sCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AA3IZ;AA6IY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0CAAA;AA3Id;AAkJK;EACC,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mDAAA;EACA,kBAAA;AAhJN;AAkJM;EACE,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,aAAA;EACA,+BAAA;EACA,iDAAA;EACA,gBAAA;EAEA,iBAAA;EACA,aAAA;EACA,sBAAA;AAjJR;AAmJQ;EACE,kCAAA;AAjJV;AAoJQ;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAlJV;AAoJU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAlJZ;AAoJY;EACE,WAAA;EACA,YAAA;AAlJd;AAkLQ;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AAhLV;AAmLQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAjLV;AAoLQ;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;AAlLV;AAoLU;EACE,mBAAA;AAlLZ;AAqLU;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AAnLZ;AAsLU;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AApLZ;AAsLY;EACE,2BAAA;EACA,gBAAA;AApLd;AAuLY;EACE,2BAAA;EACA,gBAAA;AArLd;AAwLY;EACE,0BAAA;EACA,gBAAA;AAtLd;AA0LU;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AAxLZ;AA0LY;EACE,0BAAA;AAxLd;AA8LQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AA5LV;AA8LU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AA5LZ;AA8LY;EACE,yBAAA;EACA,sBAAA;AA5Ld;AA+LY;EACE,uDAAA;EACA,2BAAA;AA7Ld;AAgMY;EACE,2BAAA;AA9Ld;AAmMQ;EACE,gBAAA;AAjMV;AAmMU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAjMZ;AAmMY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,2BAAA;AAjMd;AAmMc;EACE,uDAAA;AAjMhB;AAoMc;EACE,gCAAA;EACA,qBAAA;AAlMhB;AAuMU;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AArMZ;AAuMY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AArMd;AAuMc;EACE,gCAAA;EACA,2BAAA;EACA,wCAAA;AArMhB;AAuMgB;EACE,YAAA;EACA,gBAAA;AArMlB;AAyMc;EACE,+BAAA;EACA,wBAAA;AAvMhB;AAyMgB;EACE,YAAA;EACA,gBAAA;AAvMlB;AA8MQ;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA5MV;AA8MU;EACE,mBAAA;AA5MZ;AA+MU;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA7MZ;AA+MY;EACE,sBAAA;EACA,2BAAA;AA7Md;AAkNQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAhNV;AAkNU;EACE,gCAAA;EACA,2BAAA;AAhNZ;AAkNY;EACE,YAAA;EACA,2BAAA;AAhNd;AAoNU;EACE,+BAAA;EACA,0BAAA;AAlNZ;AAoNY;EACE,YAAA;EACA,0BAAA;AAlNd;AAuNQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AArNV;AAuNU;EACE,gCAAA;EACA,2BAAA;AArNZ;AAuNY;EACE,mBAAA;EACA,2BAAA;AArNd;AAwNY;EACE,YAAA;EACA,2BAAA;AAtNd;AA0NU;EACE,+BAAA;EACA,0BAAA;AAxNZ;AA0NY;EACE,mBAAA;EACA,2BAAA;AAxNd;AA2NY;EACE,YAAA;EACA,0BAAA;AAzNd;AA8NQ;EACE,kBAAA;AA5NV;AA8NU;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4CAAA;AA5NZ;AAgOQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AA9NV;AAgOU;EACE,UAAA;AA9NZ;AAiOU;EACE,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,uBAAA;AA/NZ;AAiOY;EACE,WAAA;EACA,gCAAA;EACA,YAAA;AA/Nd;AAiOc;EACE,gCAAA;AA/NhB;AAkOc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AAhOhB;AAoOY;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAlOd;AAoOc;EACE,mBAAA;AAlOhB;AAqOc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AAnOhB;AAwOU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAtOZ;AAwOY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;AAtOd;AAwOc;EACE,2BAAA;AAtOhB;AA0OY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,sCAAA;AAxOd;AA4OU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,sCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AA1OZ;AA4OY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0CAAA;AA1Od;AAiPM;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mDAAA;EACA,kBAAA;AA/ON;AAiPM;EACE,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,aAAA;EACA,+BAAA;EACA,iDAAA;EACA,gBAAA;EAEA,iBAAA;EACA,aAAA;EACA,sBAAA;AAhPR;AAkPQ;EACE,kCAAA;AAhPV;AAmPQ;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAjPV;AAmPU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAjPZ;AAmPY;EACE,WAAA;EACA,YAAA;AAjPd;AAiRQ;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AA/QV;AAkRQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAhRV;AAmRQ;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;AAjRV;AAmRU;EACE,mBAAA;AAjRZ;AAoRU;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AAlRZ;AAqRU;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAnRZ;AAqRY;EACE,2BAAA;EACA,gBAAA;AAnRd;AAsRY;EACE,2BAAA;EACA,gBAAA;AApRd;AAuRY;EACE,0BAAA;EACA,gBAAA;AArRd;AAyRU;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AAvRZ;AAyRY;EACE,0BAAA;AAvRd;AA6RQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AA3RV;AA6RU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AA3RZ;AA6RY;EACE,yBAAA;EACA,sBAAA;AA3Rd;AA8RY;EACE,uDAAA;EACA,2BAAA;AA5Rd;AA+RY;EACE,2BAAA;AA7Rd;AAkSQ;EACE,gBAAA;AAhSV;AAkSU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAhSZ;AAkSY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,2BAAA;AAhSd;AAkSc;EACE,uDAAA;AAhShB;AAmSc;EACE,gCAAA;EACA,qBAAA;AAjShB;AAsSU;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AApSZ;AAsSY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AApSd;AAsSc;EACE,gCAAA;EACA,2BAAA;EACA,wCAAA;AApShB;AAsSgB;EACE,YAAA;EACA,gBAAA;AApSlB;AAwSc;EACE,+BAAA;EACA,wBAAA;AAtShB;AAwSgB;EACE,YAAA;EACA,gBAAA;AAtSlB;AA6SQ;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA3SV;AA6SU;EACE,mBAAA;AA3SZ;AA8SU;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA5SZ;AA8SY;EACE,sBAAA;EACA,2BAAA;AA5Sd;AAiTQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AA/SV;AAiTU;EACE,gCAAA;EACA,2BAAA;AA/SZ;AAiTY;EACE,YAAA;EACA,2BAAA;AA/Sd;AAmTU;EACE,+BAAA;EACA,0BAAA;AAjTZ;AAmTY;EACE,YAAA;EACA,0BAAA;AAjTd;AAsTQ;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AApTV;AAsTU;EACE,gCAAA;EACA,2BAAA;AApTZ;AAsTY;EACE,mBAAA;EACA,2BAAA;AApTd;AAuTY;EACE,YAAA;EACA,2BAAA;AArTd;AAyTU;EACE,+BAAA;EACA,0BAAA;AAvTZ;AAyTY;EACE,mBAAA;EACA,2BAAA;AAvTd;AA0TY;EACE,YAAA;EACA,0BAAA;AAxTd;AA6TQ;EACE,kBAAA;AA3TV;AA6TU;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4CAAA;AA3TZ;AA+TQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AA7TV;AA+TU;EACE,UAAA;AA7TZ;AAgUU;EACE,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,uBAAA;AA9TZ;AAgUY;EACE,WAAA;EACA,gCAAA;EACA,YAAA;AA9Td;AAgUc;EACE,gCAAA;AA9ThB;AAiUc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AA/ThB;AAmUY;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAjUd;AAmUc;EACE,mBAAA;AAjUhB;AAoUc;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AAlUhB;AAuUU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AArUZ;AAuUY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;AArUd;AAuUc;EACE,2BAAA;AArUhB;AAyUY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,sCAAA;AAvUd;AA2UU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,sCAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAzUZ;AA2UY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0CAAA;AAzUd;AA+UI;EACE,kBAAA;EACA,WAAA;AA7UN;AAgVM;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,6BAAA;AA/UR;AAkVM;EACE,OAAA;EACA,mEAAA;AAhVR;AAmVM;EACE,QAAA;EACA,oEAAA;AAjVR;AAoVM;EACE,UAAA;AAlVR;AAqVM;EACE,UAAA;AAnVR;AAuVI;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AArVJ;AAwVE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;AAtVJ;AAkWI;EACE,yBAAA;EACA,kBAAA;EACA,qCAAA;AAhWN;AAkWM;EACE,6BAAA;AAhWR;AAqWE;EACE,WAAA;EACA,oBAAA;AAnWJ;AAuWE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sFAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;AArWJ;AAuWI;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,yCAAA;EACA,4BAAA;AArWN;AAwWI;EACE,OAAA;EACA,sFAAA;EACA,qCAAA;EACA,wCAAA;AAtWN;AAyWI;EACE,QAAA;EACA,uFAAA;EACA,sCAAA;EACA,yCAAA;AAvWN;AA2WE;EACE;IACE,mBAAA;EAzWJ;EA2WE;IACE,qBAAA;EAzWJ;AACF;AA6WI;EACE,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,kBAAA;EACA,4BAAA;AA5WN;AA8WM;EACE,yBAAA;AA5WR;AA8WQ;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AA5WV;AAiXQ;EACE,sCAAA;EACA,4CAAA;AA/WV;AAiXU;EACE,yBAAA;AA/WZ;AAkXU;EACE,mBAAA;AAhXZ;AAmXU;EACE,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAjXZ;AAsXM;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AApXR;AAsXQ;EACE,gCAAA;EACA,2BAAA;AApXV;AAsXU;EACE,YAAA;EACA,2BAAA;AApXZ;AAwXQ;EACE,+BAAA;EACA,0BAAA;AAtXV;AAwXU;EACE,YAAA;EACA,0BAAA;AAtXZ;AA2XM;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AAzXR;AA2XQ;EACE,gCAAA;EACA,2BAAA;AAzXV;AA2XU;EACE,mBAAA;AAzXZ;AA6XU;EACE,YAAA;EACA,2BAAA;AA3XZ;AA+XQ;EACE,+BAAA;EACA,0BAAA;AA7XV;AA+XU;EACE,mBAAA;AA7XZ;AAiYU;EACE,YAAA;EACA,0BAAA;AA/XZ;AAoYM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAlYR;AAoYQ;EACE,sBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlYV;AAoYU;EACE,mCAAA;EACA,YAAA;AAlYZ;AAoYY;EACE,yBAAA;AAlYd;AAsYU;EACE,gDAAA;EACA,uBAAA;AApYZ;AAsYY;EACE,yBAAA;AApYd;AA0YQ;EACE,sCAAA;EACA,YAAA;AAxYV;AA0YU;EACE,yBAAA;AAxYZ;AA6YM;EACE,aAAA;EACA,WAAA;AA3YR;AA6YQ;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AA3YV;AA6YU;EACE,gCAAA;EACA,YAAA;AA3YZ;AA6YY;EACE,gCAAA;AA3Yd;AA8YY;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AA5Yd;AAgZU;EACE,gCAAA;EACA,YAAA;AA9YZ;AAgZY;EACE,mBAAA;AA9Yd;AAiZY;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;AA/Yd;AAwZE;EAjsEF;IAksEI,aAAA;EArZF;EAuZE;IACE,eAAA;IACA,mBAAA;EArZJ;EAwZE;IACE,eAAA;IACA,sBAAA;IACA,YAAA;EAtZJ;EAwZI;IACE,qBAAA;IACA,iBAAA;EAtZN;EAwZM;IACE,gCAAA;EAtZR;EA2ZE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAzZJ;EA2ZI;IACE,8BAAA;IACA,WAAA;EAzZN;EA2ZM;IACE,QAAA;EAzZR;EA4ZM;IACE,QAAA;EA1ZR;EA8ZI;IACE,uBAAA;IACA,QAAA;EA5ZN;EAiaI;IACE,0BAAA;IACA,WAAA;EA/ZN;EAiaM;IACE,eAAA;IACA,gBAAA;EA/ZR;EAiaQ;IACE,UAAA;EA/ZV;EAkaQ;IACE,kBAAA;IACA,mBAAA;EAhaV;EAoaU;IACE,eAAA;IACA,iBAAA;EAlaZ;EAqaU;IACE,iBAAA;EAnaZ;EAuaQ;IACE,2DAAA;IACA,WAAA;EAraV;EAuaU;IACE,iBAAA;IACA,sBAAA;EAraZ;EAyaQ;IACE,eAAA;IACA,iBAAA;EAvaV;EA4aY;IACE,eAAA;IACA,kBAAA;EA1ad;EA6aY;IACE,kBAAA;EA3ad;EAkbI;IACE,iBAAA;EAhbN;EAkbM;IACE,uBAAA;IACA,kBAAA;EAhbR;EAmbM;IACE,uBAAA;IACA,iBAAA;EAjbR;EAobM;IACE,sBAAA;IACA,YAAA;EAlbR;EAobQ;IACE,uBAAA;IACA,iBAAA;EAlbV;EAubQ;IACE,sBAAA;IACA,kBAAA;EArbV;AACF;AA2bE;EACE;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EAzbJ;EA2bI;;;;;IAKE,cAAA;EAzbN;EA4bI;IACE,kBAAA;IACA,YAAA;IACA,aAAA;EA1bN;EA6bI;IACE,+BAAA;IACA,mBAAA;IACA,aAAA;IACA,4BAAA;IACA,wBAAA;IACA,4BAAA;EA3bN;EA8bI;IACE,YAAA;IACA,4CAAA;IACA,kBAAA;IACA,8BAAA;IACA,mBAAA;IACA,gBAAA;EA5bN;EA+bI;IACE,kBAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;IACA,qBAAA;IACA,mBAAA;IACA,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,yBAAA;EA7bN;EAicI;IACE,gBAAA;EA/bN;EAkcI;IACE,iBAAA;EAhcN;EAmcI;IACE,sBAAA;EAjcN;EAocI;IACE,wBAAA;EAlcN;EAqcI;IACE,4BAAA;EAncN;EAscI;IACE,6BAAA;EApcN;EAucI;IACE,qBAAA;EArcN;EAwcI;IACE,mBAAA;EAtcN;AACF;;AA2cA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,mCAAA;AAxcF;AAidE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,yCAAA;EACA,WAAA;AA/cJ;AAidI;EACE,kBAAA;AA/cN;AAodE;EACE,mBAAA;EACA,iBAAA;EACA,sBAAA;AAldJ;;AA6dA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AA1dF;AA4dE;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,8CAAA;EACA,mCAAA;AA1dJ;;AAmeA;EACE;IACE,UAAA;EAheF;EAkeA;IACE,aAAA;EAheF;AACF;AAoeA;EACE,kBAAA;AAleF;AAqeE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAneJ;AAqeI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAneN;AAqeM;EACE,WAAA;EACA,YAAA;AAneR;AAweE;EACE,UAAA;AAteJ;AA0eE;EACE,mBAAA;AAxeJ;;AA2eA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxeF;AA0eE;EACE,SAAA;EACA,cAAA;AAxeJ;AA2eE;EACE,aAAA;EACA,SAAA;EACA,SAAA;AAzeJ;;AAgfA;EACE;IACE,SAAA;IACA,aAAA;IACA,kBAAA;IACA,sBAAA;EA7eF;EAgfA;IACE,mBAAA;EA9eF;EAifA;IACE,sBAAA;IACA,uBAAA;EA/eF;EAifE;IACE,cAAA;IACA,mBAAA;EA/eJ;AACF;AAmfA;EACE;IACE,UAAA;IACA,2BAAA;EAjfF;EAofA;IACE,UAAA;IACA,wBAAA;EAlfF;AACF;AAqfA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAnfF;;AAsfA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAnfF;;AAsfA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AAnfF;;AAsfA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AAnfF;;AAsfA;EACE,kCAAA;AAnfF;;AAsfA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AAnfF;AAsfE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AApfJ;AAufI;EACE,gCAAA;EACA,mBAAA;EACA,YAAA;AArfN;;AA6fA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AA1fF;AA6fE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3fJ;AA+fE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AAngBJ;AAsgBI;EACE,yBAAA;AApgBN;AAwgBI;EACE,wDAAA;EACA,uBAAA;AAtgBN;AA0gBI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAxgBN;;AA6gBA;EACE;IACE,uBAAA;EA1gBF;EA6gBA;IACE,yBAAA;EA3gBF;AACF;AA8gBA;EACE,yBAAA;EACA,2BAAA;AA5gBF","sourcesContent":["@charset \"UTF-8\";\n.court-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.court-tooltip {\n  position: absolute;\n  left: 50%;\n  top: 125%; /* Show below the icon */\n  transform: translateX(-50%);\n  background: #333;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  white-space: nowrap;\n  z-index: 1000;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n  letter-spacing: 0.5px;\n}\n\n.court-tooltip-wrapper:hover .court-tooltip,\n.court-tooltip-wrapper:focus-within .court-tooltip {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.court-tooltip::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #333;\n}\n\n.super-admin-module {\n  --primary-light: #eff6ff;\n  --primary-hover: #1d4ed8;\n  --text-dark: #111827;\n  --text-medium: #374151;\n  --text-light: #6b7280;\n  --text-muted: #9ca3af;\n  --background: #f8fafc;\n  --white: #ffffff;\n  --border: #e5e7eb;\n  --border-light: #f3f4f6;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1);\n  --success-color: #059669;\n  --success-light: #ecfdf5;\n  --danger-color: #dc2626;\n  --danger-light: #fef2f2;\n  --warning-color: #d97706;\n  --warning-light: #fffbeb;\n  --info-color: #0891b2;\n  --radius-sm: 8px;\n  --radius: 12px;\n  --radius-lg: 16px;\n  min-height: 100vh;\n  background-color: var(--background);\n  padding: 2rem;\n}\n.super-admin-module h1 {\n  text-align: center;\n  margin-bottom: 1rem;\n  font-size: 2rem;\n  font-weight: 800;\n  background-color: var(--primary-color);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: -0.025em;\n}\n.super-admin-module .tabs {\n  padding: 4px;\n  display: flex;\n  justify-content: center;\n  gap: 2px;\n  margin-bottom: 1.5rem;\n  background-color: #e2e8f0;\n  border-radius: 8px;\n  max-width: 450px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.super-admin-module .tabs button {\n  flex: 1;\n  padding: 8px 18px;\n  border: 2px solid transparent;\n  background-color: transparent;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--text-light);\n  text-transform: capitalize;\n  letter-spacing: 0.025em;\n}\n.super-admin-module .tabs button:hover:not(.active) {\n  color: var(--text-medium);\n  border-color: var(--border);\n}\n.super-admin-module .tabs button.active {\n  background-color: #fff;\n  color: #000;\n}\n.super-admin-module .invoices-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  position: relative;\n}\n.super-admin-module .invoices-header .left-section {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons {\n  display: flex;\n  gap: 0.5rem;\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--border-light);\n  color: var(--text-medium);\n  position: relative;\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn:hover {\n  background: var(--border);\n  color: var(--text-dark);\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn.active {\n  background: var(--primary-light);\n  color: var(--primary-color);\n  border: 1px solid var(--primary-color);\n}\n.super-admin-module .invoices-header .left-section .filter-sort-icons .icon-btn .filter-indicator {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background-color: var(--primary-color);\n  border-radius: 50%;\n  border: 2px solid white;\n}\n.super-admin-module .invoices-header .left-section .view-toggle-wrapper {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.super-admin-module .invoices-header .left-section .view-toggle-wrapper .view-toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n.super-admin-module .invoices-header .action-button-container {\n  display: flex;\n  gap: 10px;\n  justify-content: end;\n}\n.super-admin-module .invoices-header .action-button-container .add-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 18px;\n  background-color: var(--primary-color);\n  color: var(--white);\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.025em;\n}\n.super-admin-module .invoices-header .action-button-container .add-button .add-icon {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1;\n}\n.super-admin-module .invoices-header .action-button-container .add-button:active {\n  transform: translateY(0);\n}\n.super-admin-module .filter-dropdown {\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 10px;\n  box-shadow: var(--shadow-lg);\n  z-index: 99999;\n  width: 365px;\n  max-height: 40vh;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.super-admin-module .filter-dropdown .filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-light);\n  flex-shrink: 0;\n}\n.super-admin-module .filter-dropdown .filter-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-dark);\n}\n.super-admin-module .filter-dropdown .filter-header .close-filter {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  color: var(--text-medium);\n  transition: all 0.2s ease;\n}\n.super-admin-module .filter-dropdown .filter-header .close-filter:hover {\n  background-color: var(--border-light);\n  color: var(--text-dark);\n}\n.super-admin-module .filter-dropdown .filter-header .close-filter svg {\n  width: 14px;\n  height: 14px;\n}\n.super-admin-module .filter-dropdown .filter-content {\n  padding: 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n  max-height: calc(80vh - 120px);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group {\n  margin-bottom: 1rem;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group:last-child {\n  margin-bottom: 1rem;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-dark);\n  font-size: 0.9rem;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group select {\n  width: 100%;\n  padding: 0.625rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background-color: var(--white);\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-group select:hover {\n  border-color: var(--text-medium);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  margin-top: auto;\n  flex-shrink: 0;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button {\n  flex: 1;\n  padding: 0.625rem 1rem;\n  border: 1px solid;\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters {\n  background-color: var(--white);\n  border-color: var(--border);\n  color: var(--text-medium);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters:hover:not(:disabled) {\n  background-color: var(--border-light);\n  border-color: var(--text-medium);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button.clear-filters:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button.apply-filters {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n  color: var(--white);\n}\n.super-admin-module .filter-dropdown .filter-content .filter-actions button.apply-filters:hover {\n  background-color: var(--primary-hover);\n  border-color: var(--primary-hover);\n}\n.super-admin-module .no-results {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: var(--text-medium);\n  background: var(--white);\n  border-radius: var(--radius);\n  border: 1px solid var(--border-light);\n}\n.super-admin-module .no-results p {\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n.super-admin-module .no-results .clear-filters-btn {\n  padding: 0.625rem 1.25rem;\n  background-color: var(--primary-color);\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .no-results .clear-filters-btn:hover {\n  background-color: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 2rem;\n  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  align-items: start;\n}\n.super-admin-module .tab-content .card-container .card {\n  position: relative;\n  background: var(--white);\n  border: 1px solid var(--border);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  min-height: 465px;\n  display: flex;\n  flex-direction: column;\n}\n.super-admin-module .tab-content .card-container .card:hover {\n  border-color: var(--primary-light);\n}\n.super-admin-module .tab-content .card-container .card .card-actions {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  display: flex;\n  gap: 0.5rem;\n  transition: opacity 0.3s ease;\n}\n.super-admin-module .tab-content .card-container .card .card-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n}\n.super-admin-module .tab-content .card-container .card .card-actions button svg {\n  width: 16px;\n  height: 16px;\n}\n.super-admin-module .tab-content .card-container .card h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--text-dark);\n  font-size: 1.4rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  padding-right: 5rem;\n  line-height: 1.3;\n}\n.super-admin-module .tab-content .card-container .card .card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex-grow: 1;\n}\n.super-admin-module .tab-content .card-container .card .info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container .card .info-item:last-child {\n  border-bottom: none;\n}\n.super-admin-module .tab-content .card-container .card .info-item .label {\n  font-weight: 600;\n  color: var(--text-medium);\n  min-width: 80px;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container .card .info-item .value {\n  color: var(--text-light);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  flex: 1;\n}\n.super-admin-module .tab-content .card-container .card .info-item .value.highlight {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container .card .info-item .value.success {\n  color: var(--success-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container .card .info-item .value.danger {\n  color: var(--danger-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container .card .info-item a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container .card .info-item a:hover {\n  text-decoration: underline;\n}\n.super-admin-module .tab-content .card-container .card .accordion-header {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: var(--primary-light);\n  border: none;\n  cursor: pointer;\n  padding: 0.75rem;\n  border-radius: var(--radius-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n}\n.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle span {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle:hover {\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container .card .rights-container {\n  margin-top: 1rem;\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  color: var(--text-medium);\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-header .accordion-toggle:hover {\n  background: var(--primary-light);\n  transform: scale(1.1);\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.5rem;\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.enabled {\n  background: var(--success-light);\n  color: var(--success-color);\n  border: 1px solid rgba(5, 150, 105, 0.2);\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.enabled::before {\n  content: \"✓\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.disabled {\n  background: var(--border-light);\n  color: var(--text-muted);\n}\n.super-admin-module .tab-content .card-container .card .rights-container .rights-grid .right-item.disabled::before {\n  content: \"✕\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container .card .expandable-content {\n  overflow: hidden;\n  height: 0;\n  opacity: 0;\n}\n.super-admin-module .tab-content .card-container .card .expandable-content .card-content {\n  padding-top: 0.5rem;\n}\n.super-admin-module .tab-content .card-container .card .expandable-content .rights-container {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container .card .expandable-content .rights-container .rights-header {\n  margin-bottom: 0.75rem;\n  justify-content: flex-start;\n}\n.super-admin-module .tab-content .card-container .card .status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container .card .status-badge.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container .card .status-badge.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container .card .status-badge.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container .card .status-badge.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border: none;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.active:hover {\n  background: #d1fae5;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive:hover {\n  background: #fecaca;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container .card .status-toggle-btn.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container .card .sync-courts-section {\n  margin-top: 1.5rem;\n}\n.super-admin-module .tab-content .card-container .card .sync-courts-section .sync-courts-header {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-button-wrapper {\n  width: 49%;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn {\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync {\n  width: 100%;\n  background: var(--primary-color);\n  color: white;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.high-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync {\n  width: 49%;\n  background: var(--info-color);\n  color: white;\n  cursor: pointer;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {\n  background: #0e7490;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .sync-btn.district-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip {\n  position: absolute;\n  top: -45px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--text-dark);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip .check-status-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  cursor: pointer;\n  font-size: 0.75rem;\n  text-decoration: underline;\n  padding: 0;\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip .check-status-btn:hover {\n  color: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .status-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--text-dark);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .processing-tooltip {\n  position: absolute;\n  top: -35px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--warning-color);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container .card .sync-buttons .processing-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--warning-color);\n}\n.super-admin-module .tab-content .card-container-plans {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 2rem;\n  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  align-items: start;\n}\n.super-admin-module .tab-content .card-container-plans .card {\n  position: relative;\n  background: var(--white);\n  border: 1px solid var(--border);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n}\n.super-admin-module .tab-content .card-container-plans .card:hover {\n  border-color: var(--primary-light);\n}\n.super-admin-module .tab-content .card-container-plans .card .card-actions {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  display: flex;\n  gap: 0.5rem;\n  transition: opacity 0.3s ease;\n}\n.super-admin-module .tab-content .card-container-plans .card .card-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .card-actions button svg {\n  width: 16px;\n  height: 16px;\n}\n.super-admin-module .tab-content .card-container-plans .card h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--text-dark);\n  font-size: 1.4rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  padding-right: 5rem;\n  line-height: 1.3;\n}\n.super-admin-module .tab-content .card-container-plans .card .card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex-grow: 1;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item:last-child {\n  border-bottom: none;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item .label {\n  font-weight: 600;\n  color: var(--text-medium);\n  min-width: 80px;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item .value {\n  color: var(--text-light);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  flex: 1;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item .value.highlight {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item .value.success {\n  color: var(--success-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item .value.danger {\n  color: var(--danger-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container-plans .card .info-item a:hover {\n  text-decoration: underline;\n}\n.super-admin-module .tab-content .card-container-plans .card .accordion-header {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: var(--primary-light);\n  border: none;\n  cursor: pointer;\n  padding: 0.75rem;\n  border-radius: var(--radius-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n}\n.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle span {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .accordion-header .accordion-toggle:hover {\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container {\n  margin-top: 1rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  color: var(--text-medium);\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-header .accordion-toggle:hover {\n  background: var(--primary-light);\n  transform: scale(1.1);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.5rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.enabled {\n  background: var(--success-light);\n  color: var(--success-color);\n  border: 1px solid rgba(5, 150, 105, 0.2);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.enabled::before {\n  content: \"✓\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.disabled {\n  background: var(--border-light);\n  color: var(--text-muted);\n}\n.super-admin-module .tab-content .card-container-plans .card .rights-container .rights-grid .right-item.disabled::before {\n  content: \"✕\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container-plans .card .expandable-content {\n  overflow: hidden;\n  height: 0;\n  opacity: 0;\n}\n.super-admin-module .tab-content .card-container-plans .card .expandable-content .card-content {\n  padding-top: 0.5rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .expandable-content .rights-container {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-plans .card .expandable-content .rights-container .rights-header {\n  margin-bottom: 0.75rem;\n  justify-content: flex-start;\n}\n.super-admin-module .tab-content .card-container-plans .card .status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-plans .card .status-badge.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-badge.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-badge.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-badge.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border: none;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active:hover {\n  background: #d1fae5;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive:hover {\n  background: #fecaca;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container-plans .card .status-toggle-btn.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-courts-section {\n  margin-top: 1.5rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-courts-section .sync-courts-header {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-button-wrapper {\n  width: 49%;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn {\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync {\n  width: 100%;\n  background: var(--primary-color);\n  color: white;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.high-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync {\n  width: 49%;\n  background: var(--info-color);\n  color: white;\n  cursor: pointer;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {\n  background: #0e7490;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .sync-btn.district-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip {\n  position: absolute;\n  top: -45px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--text-dark);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip .check-status-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  cursor: pointer;\n  font-size: 0.75rem;\n  text-decoration: underline;\n  padding: 0;\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip .check-status-btn:hover {\n  color: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .status-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--text-dark);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .processing-tooltip {\n  position: absolute;\n  top: -35px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--warning-color);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container-plans .card .sync-buttons .processing-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--warning-color);\n}\n.super-admin-module .tab-content .card-container-company {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 2rem;\n  animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  align-items: start;\n}\n.super-admin-module .tab-content .card-container-company .card {\n  position: relative;\n  background: var(--white);\n  border: 1px solid var(--border);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  min-height: 700px;\n  display: flex;\n  flex-direction: column;\n}\n.super-admin-module .tab-content .card-container-company .card:hover {\n  border-color: var(--primary-light);\n}\n.super-admin-module .tab-content .card-container-company .card .card-actions {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  display: flex;\n  gap: 0.5rem;\n  transition: opacity 0.3s ease;\n}\n.super-admin-module .tab-content .card-container-company .card .card-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n}\n.super-admin-module .tab-content .card-container-company .card .card-actions button svg {\n  width: 16px;\n  height: 16px;\n}\n.super-admin-module .tab-content .card-container-company .card h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--text-dark);\n  font-size: 1.4rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  padding-right: 5rem;\n  line-height: 1.3;\n}\n.super-admin-module .tab-content .card-container-company .card .card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex-grow: 1;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-company .card .info-item:last-child {\n  border-bottom: none;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item .label {\n  font-weight: 600;\n  color: var(--text-medium);\n  min-width: 80px;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item .value {\n  color: var(--text-light);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  flex: 1;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item .value.highlight {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item .value.success {\n  color: var(--success-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item .value.danger {\n  color: var(--danger-color);\n  font-weight: 600;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container-company .card .info-item a:hover {\n  text-decoration: underline;\n}\n.super-admin-module .tab-content .card-container-company .card .accordion-header {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: var(--primary-light);\n  border: none;\n  cursor: pointer;\n  padding: 0.75rem;\n  border-radius: var(--radius-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n}\n.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle span {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-company .card .accordion-header .accordion-toggle:hover {\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container {\n  margin-top: 1rem;\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  color: var(--text-medium);\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--primary-color);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle svg {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-header .accordion-toggle:hover {\n  background: var(--primary-light);\n  transform: scale(1.1);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.5rem;\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.enabled {\n  background: var(--success-light);\n  color: var(--success-color);\n  border: 1px solid rgba(5, 150, 105, 0.2);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.enabled::before {\n  content: \"✓\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.disabled {\n  background: var(--border-light);\n  color: var(--text-muted);\n}\n.super-admin-module .tab-content .card-container-company .card .rights-container .rights-grid .right-item.disabled::before {\n  content: \"✕\";\n  font-weight: 700;\n}\n.super-admin-module .tab-content .card-container-company .card .expandable-content {\n  overflow: hidden;\n  height: 0;\n  opacity: 0;\n}\n.super-admin-module .tab-content .card-container-company .card .expandable-content .card-content {\n  padding-top: 0.5rem;\n}\n.super-admin-module .tab-content .card-container-company .card .expandable-content .rights-container {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-company .card .expandable-content .rights-container .rights-header {\n  margin-bottom: 0.75rem;\n  justify-content: flex-start;\n}\n.super-admin-module .tab-content .card-container-company .card .status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .card-container-company .card .status-badge.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-badge.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-badge.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-badge.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border: none;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active:hover {\n  background: #d1fae5;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive:hover {\n  background: #fecaca;\n  transform: translateY(-1px);\n}\n.super-admin-module .tab-content .card-container-company .card .status-toggle-btn.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-courts-section {\n  margin-top: 1.5rem;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-courts-section .sync-courts-header {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-button-wrapper {\n  width: 49%;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn {\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync {\n  width: 100%;\n  background: var(--primary-color);\n  color: white;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.high-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync {\n  width: 49%;\n  background: var(--info-color);\n  color: white;\n  cursor: pointer;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync:hover:not(:disabled) {\n  background: #0e7490;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .sync-btn.district-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip {\n  position: absolute;\n  top: -45px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--text-dark);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip .check-status-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  cursor: pointer;\n  font-size: 0.75rem;\n  text-decoration: underline;\n  padding: 0;\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip .check-status-btn:hover {\n  color: var(--primary-hover);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .status-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--text-dark);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .processing-tooltip {\n  position: absolute;\n  top: -35px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--warning-color);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: var(--shadow);\n}\n.super-admin-module .tab-content .card-container-company .card .sync-buttons .processing-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--warning-color);\n}\n.super-admin-module .tab-content .table-wrapper {\n  position: relative;\n  width: 100%;\n}\n.super-admin-module .tab-content .table-wrapper::before, .super-admin-module .tab-content .table-wrapper::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  z-index: 11;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.super-admin-module .tab-content .table-wrapper::before {\n  left: 0;\n  background: linear-gradient(90deg, rgba(0, 0, 0, 0.1), transparent);\n}\n.super-admin-module .tab-content .table-wrapper::after {\n  right: 0;\n  background: linear-gradient(270deg, rgba(0, 0, 0, 0.1), transparent);\n}\n.super-admin-module .tab-content .table-wrapper.show-left-fade::before {\n  opacity: 1;\n}\n.super-admin-module .tab-content .table-wrapper.show-right-fade::after {\n  opacity: 1;\n}\n.super-admin-module .tab-content .table-container {\n  overflow-x: auto;\n  width: 100%;\n  overflow-y: hidden;\n  position: relative;\n}\n.super-admin-module .tab-content .top-scrollbar-container {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  height: 17px;\n  margin-bottom: 8px;\n  background-color: var(--background);\n  border-radius: var(--radius-sm);\n}\n.super-admin-module .tab-content .top-scrollbar-container::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 6px;\n  border: 2px solid var(--border-light);\n}\n.super-admin-module .tab-content .top-scrollbar-container::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n.super-admin-module .tab-content .top-scrollbar-content {\n  height: 1px;\n  pointer-events: none;\n}\n.super-admin-module .tab-content .scroll-indicator {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));\n  backdrop-filter: blur(2px);\n  pointer-events: none;\n  z-index: 10;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.super-admin-module .tab-content .scroll-indicator span {\n  font-size: 18px;\n  font-weight: bold;\n  color: var(--primary-color);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  animation: pulse 2s infinite;\n}\n.super-admin-module .tab-content .scroll-indicator.left-scroll {\n  left: 0;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.3));\n  border-top-left-radius: var(--radius);\n  border-bottom-left-radius: var(--radius);\n}\n.super-admin-module .tab-content .scroll-indicator.right-scroll {\n  right: 0;\n  background: linear-gradient(270deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.3));\n  border-top-right-radius: var(--radius);\n  border-bottom-right-radius: var(--radius);\n}\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n.super-admin-module .tab-content .data-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  box-shadow: var(--shadow-sm);\n}\n.super-admin-module .tab-content .data-table thead {\n  background-color: #f1f5f9;\n}\n.super-admin-module .tab-content .data-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: var(--text-dark);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-size: 0.875rem;\n}\n.super-admin-module .tab-content .data-table tbody tr {\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid var(--border-light);\n}\n.super-admin-module .tab-content .data-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.super-admin-module .tab-content .data-table tbody tr:last-child {\n  border-bottom: none;\n}\n.super-admin-module .tab-content .data-table tbody tr td {\n  padding: 0.9rem 1rem;\n  color: var(--text-medium);\n  font-size: 0.9rem;\n  vertical-align: middle;\n}\n.super-admin-module .tab-content .data-table .status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.super-admin-module .tab-content .data-table .status-badge.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .data-table .status-badge.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .data-table .status-badge.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .data-table .status-badge.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border: none;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.active {\n  background: var(--success-light);\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.active:hover {\n  background: #d1fae5;\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.active::before {\n  content: \"●\";\n  color: var(--success-color);\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.inactive {\n  background: var(--danger-light);\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.inactive:hover {\n  background: #fecaca;\n}\n.super-admin-module .tab-content .data-table .status-toggle-btn.inactive::before {\n  content: \"●\";\n  color: var(--danger-color);\n}\n.super-admin-module .tab-content .data-table .table-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n.super-admin-module .tab-content .data-table .table-actions button {\n  padding: 0.3rem 0.6rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.super-admin-module .tab-content .data-table .table-actions button.edit-btn {\n  background-color: var(--info-color);\n  color: white;\n}\n.super-admin-module .tab-content .data-table .table-actions button.edit-btn:hover {\n  background-color: #0e7490;\n}\n.super-admin-module .tab-content .data-table .table-actions button.del-btn {\n  background-color: var(--danger-color) !important;\n  color: white !important;\n}\n.super-admin-module .tab-content .data-table .table-actions button.del-btn:hover {\n  background-color: #b91c1c;\n}\n.super-admin-module .tab-content .data-table .table-actions .court-details-btn {\n  background-color: var(--warning-color);\n  color: white;\n}\n.super-admin-module .tab-content .data-table .table-actions .court-details-btn:hover {\n  background-color: #b45309;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small {\n  padding: 0.3rem 0.6rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync {\n  background: var(--primary-color);\n  color: white;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.high-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync {\n  background: var(--primary-color);\n  color: white;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync:hover:not(:disabled) {\n  background: #0e7490;\n}\n.super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small.district-court-sync:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n@media (max-width: 768px) {\n  .super-admin-module {\n    padding: 1rem;\n  }\n  .super-admin-module h1 {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n  }\n  .super-admin-module .tabs {\n    max-width: 100%;\n    flex-direction: column;\n    height: auto;\n  }\n  .super-admin-module .tabs button {\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n  }\n  .super-admin-module .tabs button.active {\n    background: var(--primary-color);\n  }\n  .super-admin-module .invoices-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n  .super-admin-module .invoices-header .left-section {\n    justify-content: space-between;\n    width: 100%;\n  }\n  .super-admin-module .invoices-header .left-section .filter-sort-icons {\n    order: 1;\n  }\n  .super-admin-module .invoices-header .left-section .view-toggle-wrapper {\n    order: 2;\n  }\n  .super-admin-module .invoices-header .action-button-container {\n    justify-content: center;\n    order: 3;\n  }\n  .super-admin-module .tab-content .card-container {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  .super-admin-module .tab-content .card-container .card {\n    padding: 1.5rem;\n    min-height: auto;\n  }\n  .super-admin-module .tab-content .card-container .card .card-actions {\n    opacity: 1;\n  }\n  .super-admin-module .tab-content .card-container .card h3 {\n    font-size: 1.25rem;\n    padding-right: 4rem;\n  }\n  .super-admin-module .tab-content .card-container .card .info-item .label {\n    min-width: 70px;\n    font-size: 0.8rem;\n  }\n  .super-admin-module .tab-content .card-container .card .info-item .value {\n    font-size: 0.9rem;\n  }\n  .super-admin-module .tab-content .card-container .card .rights-grid {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 0.4rem;\n  }\n  .super-admin-module .tab-content .card-container .card .rights-grid .right-item {\n    font-size: 0.8rem;\n    padding: 0.4rem 0.6rem;\n  }\n  .super-admin-module .tab-content .card-container .card .accordion-header .accordion-toggle {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n  .super-admin-module .tab-content .card-container .card .expandable-content .info-item .label {\n    min-width: 60px;\n    font-size: 0.75rem;\n  }\n  .super-admin-module .tab-content .card-container .card .expandable-content .info-item .value {\n    font-size: 0.85rem;\n  }\n  .super-admin-module .tab-content .data-table {\n    font-size: 0.8rem;\n  }\n  .super-admin-module .tab-content .data-table thead th {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n  .super-admin-module .tab-content .data-table tbody td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.8rem;\n  }\n  .super-admin-module .tab-content .data-table .table-actions {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  .super-admin-module .tab-content .data-table .table-actions button {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.7rem;\n  }\n  .super-admin-module .tab-content .data-table .table-sync-actions .sync-btn-small {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.65rem;\n  }\n}\n@media (max-width: 480px) {\n  .super-admin-module .data-table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  .super-admin-module .data-table thead,\n  .super-admin-module .data-table tbody,\n  .super-admin-module .data-table th,\n  .super-admin-module .data-table td,\n  .super-admin-module .data-table tr {\n    display: block;\n  }\n  .super-admin-module .data-table thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  .super-admin-module .data-table tr {\n    border: 1px solid var(--border);\n    margin-bottom: 1rem;\n    padding: 1rem;\n    border-radius: var(--radius);\n    background: var(--white);\n    box-shadow: var(--shadow-sm);\n  }\n  .super-admin-module .data-table td {\n    border: none;\n    border-bottom: 1px solid var(--border-light);\n    position: relative;\n    padding: 0.75rem 0 0.75rem 35%;\n    white-space: normal;\n    text-align: left;\n  }\n  .super-admin-module .data-table td:before {\n    position: absolute;\n    top: 0.75rem;\n    left: 0.5rem;\n    width: 30%;\n    padding-right: 0.5rem;\n    white-space: nowrap;\n    font-weight: 600;\n    color: var(--text-medium);\n    font-size: 0.75rem;\n    text-transform: uppercase;\n  }\n  .super-admin-module .data-table td:nth-child(1):before {\n    content: \"Name:\";\n  }\n  .super-admin-module .data-table td:nth-child(2):before {\n    content: \"Email:\";\n  }\n  .super-admin-module .data-table td:nth-child(3):before {\n    content: \"Role/Phone:\";\n  }\n  .super-admin-module .data-table td:nth-child(4):before {\n    content: \"Status/Users:\";\n  }\n  .super-admin-module .data-table td:nth-child(5):before {\n    content: \"Created/Branches:\";\n  }\n  .super-admin-module .data-table td:nth-child(6):before {\n    content: \"Branches/Scraping:\";\n  }\n  .super-admin-module .data-table td:nth-child(7):before {\n    content: \"Type/Sync:\";\n  }\n  .super-admin-module .data-table td:nth-child(8):before {\n    content: \"Actions:\";\n  }\n}\n\n.action-required-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem;\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: subtle-pulse 2s infinite;\n}\n.action-required-badge.card-badge-positioned {\n  position: absolute;\n  top: 4.5rem;\n  right: 0.75rem;\n  font-size: 0.7rem;\n  padding: 0.25rem 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 10;\n}\n.action-required-badge.card-badge-positioned::before {\n  font-size: 0.75rem;\n}\n.action-required-badge.table-badge {\n  margin-left: 0.5rem;\n  font-size: 0.7rem;\n  padding: 0.2rem 0.4rem;\n}\n\n.horizontal-scroll-badge {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 0.75rem;\n  padding-right: 0.5rem;\n}\n.horizontal-scroll-badge .action-required-badge.table-badge {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.4rem 0.75rem;\n  border-radius: 0.5rem;\n  text-transform: none;\n  letter-spacing: 0.025em;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);\n  animation: subtle-pulse 2s infinite;\n}\n\n@keyframes gentle-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n}\n.card {\n  position: relative;\n}\n.card .card-actions {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  display: flex;\n  gap: 0.5rem;\n  transition: opacity 0.3s ease;\n}\n.card .card-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n}\n.card .card-actions button svg {\n  width: 16px;\n  height: 16px;\n}\n.card:hover .card-actions {\n  opacity: 1;\n}\n.card h3 {\n  padding-right: 6rem;\n}\n\n.sa-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.sa-dashboard-header h1 {\n  margin: 0;\n  flex-shrink: 0;\n}\n.sa-dashboard-header .tabs {\n  display: flex;\n  gap: 10px;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .action-required-badge.card-badge-positioned {\n    top: 4rem;\n    right: 0.5rem;\n    font-size: 0.65rem;\n    padding: 0.2rem 0.4rem;\n  }\n  .card h3 {\n    padding-right: 5rem;\n  }\n  .table-cell-with-badge {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .table-cell-with-badge .action-required-badge {\n    margin-left: 0;\n    margin-top: 0.25rem;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.sa-search-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: 0.5rem;\n}\n\n.sa-search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.sa-search-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  background: white;\n}\n\n.sa-search-loading {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--primary-color);\n}\n\n.sa-spinner {\n  animation: spin 1s linear infinite;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0;\n  gap: 10px;\n}\n.pagination-controls button {\n  padding: 6px 12px;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  min-width: 80px;\n  text-align: center;\n}\n.pagination-controls button:disabled {\n  background: var(--primary-color);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 7px 18px;\n  background-color: #E2E8F0;\n  border-radius: 6px;\n}\n.pagination-settings label {\n  white-space: nowrap;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 400;\n}\n.pagination-settings #saPerPageSelect {\n  border: none;\n  border-radius: 6px;\n  outline: none;\n  padding: 6px 32px 6px 12px;\n  background-color: white;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  min-width: 70px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  transition: all 0.2s ease;\n  box-shadow: none !important;\n}\n.pagination-settings #saPerPageSelect:hover {\n  background-color: #fafafa;\n}\n.pagination-settings #saPerPageSelect:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n  background-color: white;\n}\n.pagination-settings #saPerPageSelect option {\n  border: none !important;\n  outline: none;\n  padding: 4px 8px;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.icon-btn.active {\n  background-color: #f0f0f0;\n  color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
